module.exports = __webpack_public_path__ + "img/ic_File_1.093df61c.svg";